import { render, staticRenderFns } from "./AddNewPeerGroup.vue?vue&type=template&id=66fa9e64&"
import script from "./AddNewPeerGroup.vue?vue&type=script&lang=js&"
export * from "./AddNewPeerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QIcon,QTooltip,QSelect,QTable,QBtn,QSpace,QTd,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QIcon,QTooltip,QSelect,QTable,QBtn,QSpace,QTd,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
